import { gql } from '@apollo/client';
import { ApolloQueryResult } from '@apollo/client';
import { useEmployeeQuery as useQuery } from '@jbc-year-end-adj/2024/hooks/graphql/useQuery';
import { ReportName } from '../../employee/types';
import { REPORT_MAP } from '../../employee/consts';

const generateQuery = (reportName: ReportName) => gql`
  query report {
    reports {
      ${reportName}
      ${reportName}Url
    }
  }
`;

type Report = {
  name: string;
  data: string;
  url: string;
};

type UseReport = (
  reportName: ReportName
) => {
  report: Report | undefined;
  loading: boolean;
  refetch: () => Promise<ApolloQueryResult<unknown>>;
};

export const useReport: UseReport = reportName => {
  const query = generateQuery(reportName);
  const { data, loading, refetch } = useQuery(query, { fetchPolicy: 'network-only' });
  const reports = data?.reports;

  if (loading) {
    return {
      report: undefined,
      loading,
      refetch
    };
  }

  return {
    report: {
      name: REPORT_MAP[reportName],
      data: reports[reportName],
      url: reports[`${reportName}Url`]
    },
    loading,
    refetch
  };
};
